import { Box, Heading, Text } from '@chakra-ui/react'
import WeAreTmg from './sections/wearetmg'
import Headquarters from './sections/headquarters'
import MapContact from '../contact_us/sections/map'

function AboutUsPage() {
  return (
    <Box >
     <WeAreTmg/> 
     <Headquarters/>
     <MapContact/>
    </Box>
  )
}

export default AboutUsPage
